'use client';

import { motion } from 'framer-motion';

export const GradientBars = ({
  bars = 20,
  colors = ['#e60a64', 'transparent', 'black'],
  borderOnly = false,
}) => {
  const gradientStyle = `linear-gradient(to top, ${colors.join(', ')})`;
  
  if (borderOnly) {
    return (
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
        {/* Top border */}
        <div className="absolute top-0 left-0 right-0 h-1">
          <div className="flex h-full w-full">
            {Array.from({ length: bars }).map((_, index) => {
              const position = index / (bars - 1);
              const center = 0.5;
              const distance = Math.abs(position - center);
              const scale = 0.3 + 0.7 * Math.pow(distance * 2, 1.2);

              return (
                <motion.div
                  key={`top-bar-${index}`}
                  className="flex-1"
                  style={{ background: gradientStyle }}
                  animate={{
                    scaleY: [scale, scale + 0.1, scale],
                    opacity: [0.8, 1, 0.8],
                  }}
                  transition={{
                    duration: 3,
                    ease: 'easeInOut',
                    repeat: Infinity,
                    repeatType: 'mirror',
                    delay: index * 0.5,
                  }}
                />
              );
            })}
          </div>
        </div>
        
        {/* Bottom border */}
        <div className="absolute bottom-0 left-0 right-0 h-1">
          <div className="flex h-full w-full">
            {Array.from({ length: bars }).map((_, index) => {
              const position = index / (bars - 1);
              const center = 0.5;
              const distance = Math.abs(position - center);
              const scale = 0.3 + 0.7 * Math.pow(distance * 2, 1.2);

              return (
                <motion.div
                  key={`bottom-bar-${index}`}
                  className="flex-1"
                  style={{ background: gradientStyle }}
                  animate={{
                    scaleY: [scale, scale + 0.1, scale],
                    opacity: [0.8, 1, 0.8],
                  }}
                  transition={{
                    duration: 3,
                    ease: 'easeInOut',
                    repeat: Infinity,
                    repeatType: 'mirror',
                    delay: index * 0.5,
                  }}
                />
              );
            })}
          </div>
        </div>
        
        {/* Left border */}
        <div className="absolute left-0 top-0 bottom-0 w-1">
          <div className="flex flex-col h-full w-full">
            {Array.from({ length: Math.floor(bars / 2) }).map((_, index) => {
              const position = index / (Math.floor(bars / 2) - 1);
              const center = 0.5;
              const distance = Math.abs(position - center);
              const scale = 0.3 + 0.7 * Math.pow(distance * 2, 1.2);

              return (
                <motion.div
                  key={`left-bar-${index}`}
                  className="flex-1"
                  style={{ background: gradientStyle }}
                  animate={{
                    scaleX: [scale, scale + 0.1, scale],
                    opacity: [0.8, 1, 0.8],
                  }}
                  transition={{
                    duration: 3,
                    ease: 'easeInOut',
                    repeat: Infinity,
                    repeatType: 'mirror',
                    delay: index * 0.3,
                  }}
                />
              );
            })}
          </div>
        </div>
        
        {/* Right border */}
        <div className="absolute right-0 top-0 bottom-0 w-1">
          <div className="flex flex-col h-full w-full">
            {Array.from({ length: Math.floor(bars / 2) }).map((_, index) => {
              const position = index / (Math.floor(bars / 2) - 1);
              const center = 0.5;
              const distance = Math.abs(position - center);
              const scale = 0.3 + 0.7 * Math.pow(distance * 2, 1.2);

              return (
                <motion.div
                  key={`right-bar-${index}`}
                  className="flex-1"
                  style={{ background: gradientStyle }}
                  animate={{
                    scaleX: [scale, scale + 0.1, scale],
                    opacity: [0.8, 1, 0.8],
                  }}
                  transition={{
                    duration: 3,
                    ease: 'easeInOut',
                    repeat: Infinity,
                    repeatType: 'mirror',
                    delay: index * 0.3,
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="absolute inset-0 z-0 overflow-hidden">
      <div className="flex h-full w-full">
        {Array.from({ length: bars }).map((_, index) => {
          const position = index / (bars - 1);
          const center = 0.5;
          const distance = Math.abs(position - center);
          const scale = 0.3 + 0.7 * Math.pow(distance * 2, 1.2);

          return (
            <motion.div
              key={`bg-bar-${index}`}
              className="flex-1 origin-bottom"
              style={{ background: gradientStyle }}
              animate={{
                scaleY: [scale, scale + 0.1, scale],
                opacity: [1, 0.95, 1],
              }}
              transition={{
                duration: 3,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'mirror',
                delay: index * 0.5,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};